import * as React from 'react'

import { Checkbox as CheckboxPresenter, IProps } from './presenter'

export const Checkbox = React.forwardRef<HTMLInputElement, IProps>(
  (props, ref) => <CheckboxPresenter {...props} ref={ref} />,
)

export default Checkbox
